import { Flex, Grid } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

// components
import LanguageButton from 'components/language-button/language-button';

// styles
import darkLogo from 'assets/images/logo-dark.svg';

const PublicPage: FunctionComponent = () => {
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();

	const [isScrolled, setIsScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setIsScrolled(window.scrollY > 0);

		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });

		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	return (
		<div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
			<div
				style={{
					position: 'sticky',
					top: 0,
					zIndex: 1000,
					background: isScrolled ? '#fff' : 'transparent',
					boxShadow: isScrolled ? '0 2px 8px rgba(0, 0, 0, 0.06)' : 'none',
					transition: 'background 0.2s, box-shadow 0.2s',
				}}>
				<div className="container">
					<Flex justify="space-between" align="center" style={{ paddingBlock: 15, paddingInline: screens.md ? 25 : 10, marginBottom: 5 }}>
						<img src={darkLogo} alt="logo" style={{ width: screens.md ? 180 : 140 }} />

						<div>
							<LanguageButton size="middle" />
						</div>
					</Flex>
				</div>
			</div>

			<div className="container" style={{ paddingBottom: 30 }}>
				<Outlet />
			</div>
		</div>
	);
};

export default PublicPage;
